const RETENTION_CHECKOUT_PENDING_KEY = 'rs_retention_checkout_pending'

export type RetentionCheckoutCancelAction = 'cancel-url' | 'browser-back'

export function readRetentionCheckoutPending(): string | null {
  try {
    return localStorage.getItem(RETENTION_CHECKOUT_PENDING_KEY)
  }
  catch {
    return null
  }
}

export function markRetentionCheckoutPending() {
  try {
    localStorage.setItem(RETENTION_CHECKOUT_PENDING_KEY, 'true')
  }
  catch {}
}

export function clearRetentionCheckoutPending() {
  try {
    localStorage.removeItem(RETENTION_CHECKOUT_PENDING_KEY)
  }
  catch {}
}

/**
 * 统一判断用户是否取消了外部支付。
 *
 * PayPal 点击取消会携带 payment_status=cancel；浏览器导航或手势返回
 * 不携带状态，只能在 pageshow/整页恢复时判定。两种情况都必须有
 * 跳转外部支付页前写入的 pending 标记，避免普通页面访问被误判。
 */
export function getRetentionCheckoutCancelAction(
  paymentStatus: unknown,
  allowBrowserBack: boolean,
): RetentionCheckoutCancelAction | null {
  if (readRetentionCheckoutPending() !== 'true')
    return null

  if (paymentStatus === 'cancel')
    return 'cancel-url'

  if (allowBrowserBack && (paymentStatus === undefined || paymentStatus === null || paymentStatus === ''))
    return 'browser-back'

  return null
}
